import { render, staticRenderFns } from "./WysiwygEditor.vue?vue&type=template&id=1c8ef150"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js"
import style0 from "./WysiwygEditor.vue?vue&type=style&index=0&id=1c8ef150&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports